let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2glzF")).then(() => parcelRequire('3zmBy'));